import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Copy, CheckCircle2 } from 'lucide-react'
import { useToast } from '@/components/ui/use-toast'
import { cn } from '@/lib/utils'

export const CopyButton = ({
	code,
	label = 'Copy Code',
	className = '',
	customMessage,
}: {
	code: string
	label?: string
	className?: string
	customMessage?: string
}) => {
	const { toast } = useToast()
	const [copied, setCopied] = useState(false)
	const placeholderWidgetId = 'YOUR_WIDGET_ID'

	const handleCopy = () => {
		navigator.clipboard
			.writeText(
				code.replace(placeholderWidgetId, 'REPLACE_WITH_YOUR_ACTUAL_ID')
			)
			.then(() => {
				setCopied(true)
				setTimeout(() => setCopied(false), 2000)
			})
			.catch(() => {
				toast({
					title: 'Error',
					description: 'Failed to copy code',
					variant: 'destructive',
				})
			})
	}

	return (
		<Button
			onClick={handleCopy}
			variant={copied ? 'outline' : 'secondary'}
			className={cn(
				'transition-all duration-200',
				copied
					? 'bg-green-50 dark:bg-green-900/50 text-green-600 dark:text-green-300 border-green-200 dark:border-green-700 hover:bg-green-50 hover:text-green-600 hover:dark:text-green-300'
					: '',
				className
			)}>
			{copied ? (
				<CheckCircle2 className="mr-2 h-4 w-4" />
			) : (
				<Copy className="mr-2 h-4 w-4" />
			)}
			{copied ? 'Copied!' : label}
		</Button>
	)
}